<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')  
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方")
                    el-select.inputWidth(v-model="dataForm.sysOrgIds",placeholder="请选择" filterable clearable multiple style="width:100%")
                        el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-col( :md='6' :sm="12")
                div(style='float:left;display:flex')
                  el-button(@click='queryList()',type='primary',size="small",icon='el-icon-search') 查 询
        el-row(style="padding-bottom:15px;" :span="24")

        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)

            el-table-column(prop='sysOrgName',header-align='center',align='center',label='主办方' width="350")
            el-table-column(prop='matchId',header-align='center',align='center',label='加盟费' )
                  template(slot-scope='scope')
                    <p v-for="item in scope.row.initialFeeModels"><span>{{item.categoryName}}</span><span v-if="item.calType==1">   固定金额:{{item.fixedAmount}}</span><span v-if="item.calType==2">   百分比:{{item.percentage}}%</span></p>
                    
            el-table-column(prop='matchName',header-align='center',align='center',label='缴费方式触发限额' )
                  template(slot-scope='scope')
                    <p v-for="item in scope.row.limitFeeModels"><span>{{item.categoryName}}</span><span>   固定金额:{{item.fixedAmount}}</span></p>
            el-table-column(prop='withdrawalFees',header-align='center',align='center',label='提现手续费(%)' width="350")
                  template(slot-scope="scope")
                      font(v-if='scope.row.withdrawalFees != null')
                        span() {{scope.row.withdrawalFees}}
            el-table-column(prop='',header-align='center',align='center',label='操作' width='150')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-2" @click="UpdateHandle(scope.row.sysOrgId,scope.row.id)" v-if="isAuth('ct:level:update')" type="text" ) 修改
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        view-info(v-if='viewVisible', ref='viewInfo', @refreshdatalist='getDataList')
</template>

<script>
import table from './table1.js'
import ViewInfo from './update'
export default {
  name: 'join-set',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      loading: null,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      // restaurants: [],
      matchId: '',
      dataForm: {
        sysOrgIds: [],
      },
      levelOptions: [],
      sysOrgList: [],
      levelDisabled: true,
      placeholderLevel: '必须先选择比赛项目',
      viewVisible: false,

    }
  },
  components: {
    ViewInfo,
  },
  mounted () {
    this.getDataList()
    this.initCity()
  },
  methods: {

    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    UpdateHandle (sysOrgId,id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(sysOrgId,id)
      })
    },
    getDataList () {
      console.log('getDataList')
      this.dataListLoading = true
      let sysOrgIds=this.dataForm.sysOrgIds.length>0?this.dataForm.sysOrgIds.join(','):''
      this.$http({
        url: this.$http.adornUrl('/frInitialFeeSetting/queryPage'),
        method: 'post',
        data: {
          page: this.pageIndex,
          rows: this.pageSize,
          sysOrgIds:sysOrgIds,
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.pageInfo.list
          this.totalPage = data.pageInfo.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}
.el-form-item__content{
   min-width: 300px;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
</style>
